import './instagram_message.js.coffee'
Namespace 'Models'

class Models.InstagramMessageStoryReply extends Models.InstagramMessage
  constructor: (builder) ->
    super(builder)
    @messageText = builder.messageText
    @storyUrl = builder.storyUrl
    @storyId = builder.storyId

  accepts: (visitor) ->
    visitor.visit_instagram_message_story_reply(@)

  getType: ->
    'story_reply'
